// ClientDetail/Components/Documents/RecordTable/TableRow.jsx
import React from "react";
import Classes from "./RecordTable.module.css";
import MoreDropDown from "./MoreDropDown";

export default function TableRow({ value, index, userId, onRemoved }) {
  return (
    <>
      <div className={Classes.customerRow} key={value._id}>
        <div className={`${Classes.rowElem} ${Classes.elem1}`}><h5>{value.Name}</h5></div>
        <div className={`${Classes.rowElem} ${Classes.elem3}`}><h5>{value.Type}</h5></div>
        <div className={`${Classes.rowElem} ${Classes.elem4}`}><h5>{value.UploadedBy}</h5></div>
        <div className={`${Classes.rowElem} ${Classes.elem5}`}><h5>{value.Uploaded}</h5></div>
        <div className={`${Classes.rowElem} ${Classes.elem7}`}>
          <MoreDropDown
            userId={userId}
            docId={value._id}
            url={value.url}
            onRemoved={() => onRemoved?.(value._id)}
          />
        </div>
      </div>

      {/* Mobile */}
      <div className={Classes.customerRowMobile}>
        <div>
          <div className={Classes.mobElem}><h4>Name</h4><h5>{value.Name}</h5></div>
          <div className={Classes.mobElem}><h4>Type</h4><h5>{value.Type}</h5></div>
        </div>
        <div>
          <div className={Classes.mobElem}><h4>Uploaded By</h4><h5>{value.UploadedBy ||'Admin'}</h5></div>
          <div className={Classes.mobElem}><h4>Uploaded</h4><h5>{value.Uploaded}</h5></div>
        </div>
        <MoreDropDown userId={userId} docId={value._id} url={value.url} onRemoved={() => onRemoved?.(value._id)} />
      </div>
    </>
  );
}
